import httpRequest from "@/utils/api";
enum API {
  fetchUserOralAnswer = "/speaking/user-answer/current-answer",
  postUserOralAnswer = "/speaking/user-answer/",
  fetchOralModelAnswer = "/speaking/model-answer/",
  postOralModelAnswer = "/speaking/model-answer/",
  fetchFreeModelAnswer = "/speaking/model-answer/free",
  fetchVipModelAnswer = "/speaking/model-answer/vip",
  generateSpeech = "/speaking/model-answer/generate-speech",
}
import { AccessType } from "@/types/topic/oralAnswerEnum";

import type { UserOralAnswer, OralModelAnswer } from "@/types/topic/oralAnswer";

export const fetchUserOralAnswerApi = (questionId: string) => {
  return httpRequest.get<UserOralAnswer>({
    url: API.fetchUserOralAnswer,
    params: {
      question_id: questionId,
    },
  });
};

export const postOralModelAnswerApi = (
  questionId: string,
  userIdeas: string,
  answer: string,
  accessType: AccessType
) => {
  return httpRequest.post({
    url: API.postOralModelAnswer,
    data: {
      questionId,
      userIdeas,
      answer,
      accessType,
    },
  });
};

export const fetchModelAnswerApi = (questionId: string) => {
  return httpRequest.get<OralModelAnswer[]>({
    url: API.fetchOralModelAnswer,
    params: {
      question_id: questionId,
    },
  });
};
export const fetchFreeModelAnswerApi = (questionId: string) => {
  return httpRequest.get<OralModelAnswer>({
    url: API.fetchFreeModelAnswer,
    params: {
      question_id: questionId,
    },
  });
};
export const fetchVipModelAnswerApi = (questionId: string) => {
  return httpRequest.get<OralModelAnswer>({
    url: API.fetchVipModelAnswer,
    params: {
      question_id: questionId,
    },
  });
};

export const postUserOralAnswerApi = (
  questionId: string,
  userIdeas: string,
  answer: string,
  notes: string | null
) => {
  return httpRequest.post({
    url: API.postUserOralAnswer,
    data: {
      questionId,
      userIdeas,
      answer,
      notes,
    },
  });
};

interface GenerateModelAnswerSpeechResponse {
  audioUrl: string;
}

export const generateModelAnswerSpeechApi = (
  questionId: string,
  accessType: AccessType
) => {
  return httpRequest.post<GenerateModelAnswerSpeechResponse>({
    url: API.generateSpeech,
    data: {
      questionId,
      accessType,
    },
  });
};
